import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-describe-text-large.tsx
/**
* icon.24.describe.text.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUgMTlhLjUuNSAwIDAgMSAwIDFoLTRhLjUuNSAwIDAgMSAwLTF6bTMtMmEuNS41IDAgMCAxIDAgMWgtN2EuNS41IDAgMCAxIDAtMXpNMTMuMjA0IDQuMDFBMiAyIDAgMCAxIDE1IDZ2NS41YS41LjUgMCAwIDEtMSAwVjZhMSAxIDAgMCAwLTEtMUg1YTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaDYuNWEuNS41IDAgMCAxIDAgMUg1YTIgMiAwIDAgMS0xLjk5LTEuNzk2TDMgMTRWNmEyIDIgMCAwIDEgMi0yaDh6TTIwLjUgMTVhLjUuNSAwIDAgMSAwIDFoLTdhLjUuNSAwIDAgMSAwLTF6bTAtMmEuNS41IDAgMCAxIDAgMWgtN2EuNS41IDAgMCAxIDAtMXptLTktNmEuNS41IDAgMCAxIC41LjV2MWEuNS41IDAgMCAxLTEgMHYtLjQ5YS4wMS4wMSAwIDAgMC0uMDEtLjAxSDkuNTFhLjAxLjAxIDAgMCAwLS4wMS4wMXYzLjk4cTAgLjAxLjAxLjAxSDEwYS41LjUgMCAwIDEgMCAxSDhhLjUuNSAwIDAgMSAwLTFoLjQ5YS4wMS4wMSAwIDAgMCAuMDEtLjAxVjguMDFBLjAxLjAxIDAgMCAwIDguNDkgOEg3LjAxYS4wMS4wMSAwIDAgMC0uMDEuMDF2LjQ5YS41LjUgMCAwIDEtMSAwdi0xYS41LjUgMCAwIDEgLjUtLjV6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-58904
*/
const Icon24DescribeTextLarge = memo(function Icon24DescribeTextLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.5 19a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm3-2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zM13.204 4.01A2 2 0 0 1 15 6v5.5a.5.5 0 0 1-1 0V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-1.99-1.796L3 14V6a2 2 0 0 1 2-2h8zM20.5 15a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm0-2a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1zm-9-6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-.49a.01.01 0 0 0-.01-.01H9.51a.01.01 0 0 0-.01.01v3.98q0 .01.01.01H10a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1h.49a.01.01 0 0 0 .01-.01V8.01A.01.01 0 0 0 8.49 8H7.01a.01.01 0 0 0-.01.01v.49a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5z"
		})
	});
});
//#endregion
export { Icon24DescribeTextLarge };

//# sourceMappingURL=icon-24-describe-text-large.js.map